import { put, select, all } from "redux-saga/effects"
import { getStartDateWithBoundaries } from "helpers/dates"
import { getUnmodeledDates, getEndDate } from "selectors/dates"
import { getPeriod } from "modules/portfolio-root/selectors/portfolios"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"

export function* handleSetSingleDate({ date }) {
  const selectedDate = date.selectedDate
  const currentPeriod = yield select(getPeriod)
  const isCustomRange = !!currentPeriod.startDate

  let startDate = null
  if (isCustomRange) {
    startDate = currentPeriod.startDate
  } else {
    const [earliestDate, latestDate, unmodeledDates, endDate] = yield all([
      select(getEarliestDate),
      select(getLatestDate),
      select(getUnmodeledDates),
      select(getEndDate),
    ])
    startDate = getStartDateWithBoundaries(endDate, currentPeriod, earliestDate, latestDate, unmodeledDates)
  }

  if (selectedDate > startDate) {
    yield put(PortfolioRootCreators.setPeriod({ startDate, endDate: selectedDate }))
    yield put(PortfolioRootCreators.resetDate())
  }
}
